import Layout from '@/layout';
var adConfig = {
  path: '/adConfig',
  component: Layout,
  redirect: '/adConfig/list',
  name: 'adConfig',
  alwaysShow: false,
  meta: {
    title: '展商广告配置',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/adConfig/list/index');
    },
    name: 'adConfigList',
    meta: {
      title: '展商广告配置'
    }
  }]
};
export default adConfig;